import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./NavigationHeader.css";
// import '../VehicleList/VehicleList.scss';
// import UserTable from "../VehicleList/Vehiclelistdatagridmui.tsx";

import HeaderFirstRow from "./HeaderFirstRow/HeaderFirstRow";

const NavigationHeader: React.FC = () => {
  useEffect(() => {
    const flexContainer: HTMLElement | null = document.getElementById("flex-container");
    const flexItems: NodeListOf<HTMLElement> | null | undefined = flexContainer?.querySelectorAll(".flex-item");
    // const pageTitle: HTMLElement | null = document.getElementById("page-title");

    flexItems?.forEach((item, index) => {
      item.addEventListener("click", function () {
        // skip the first child
        if (index === 0 || index === flexItems.length - 1) return;

        // remove active class from all items and reset background color
        flexItems.forEach((div) => {
          div.classList.remove("active");
          document.body.style.backgroundColor = "";
        });

        // add active class to clicked item
        this.classList.add("active");

        // change background color
        // const bgColor: string = this.dataset.bgColor || '';
        // document.body.style.backgroundColor = bgColor;

        // pageTitle.innerText = this.innerText;
      });
    });
  }, []);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [displayTable, setDisplayTable] = useState<boolean>(true);
  //   const handleDashboardTable =() =>{
  //     setDisplayTable(false);
  //   }

  return (
    <>
      <>
        <nav>
          <HeaderFirstRow />
          <div className="navigation-header-tabs" id="flex-container">
            <div className="flex-item" id="parent-tab">
              Vehicle Order Change
            </div>
            <Link to="/" style={{ textDecoration: "none" }}>
              <div
                className="flex-item"
                id="tab"
                title="tab"
                data-bg-color="#f0f0f0"
                onClick={() => setDisplayTable(true)}
              >
                Real Time Order Change
              </div>
            </Link>
            <div className="flex-item" id="filler-tab"></div>
          </div>
        </nav>
        <h1 id="page-title" title="page-title" className="page-title"></h1>
      </>
    </>
  );
};

export default NavigationHeader;
